// extracted by mini-css-extract-plugin
module.exports = {"item":"GoalActionList_item__21O1f","text":"GoalActionList_text__rcKth","complete":"GoalActionList_complete__5soG3"};